import axios from 'axios'
import { NvResponse, RequestName, RequestURL } from '../baseModels'
import { createG2Request } from '../createRequest'
import { useQuery } from 'react-query'
import { useBanquetProps } from 'banquet-runtime-modules'
import { Experience } from './model'
import { useRestaurantContext } from '../../contexts/RestaurantContext'
import { experiencesQueryOptions } from './useGetExperiences'
import { DateTime } from 'luxon'

export const GetExperienceQueryKey = 'experience'

const getExperience = async (
  experienceSlug: string,
  restaurantGuid: string
): Promise<Experience> =>
  axios
    .request<NvResponse<Experience>>(
      createG2Request(
        RequestURL[RequestName.GET_EXPERIENCE],
        { 'Toast-Restaurant-External-ID': restaurantGuid },
        { experienceSlug },
        undefined
      )
    )
    .then((response) => {
      return response.data.results[0]
    })

/** Looks up experience based on the slug; uses the current restaurant context to infer which restaurant to look up experience at */
export const useGetExperienceBySlug = (params: {
  experienceSlug: string | undefined | null
}) => {
  const { restaurantGuid } = useRestaurantContext()
  const { featureFlags } = useBanquetProps()
  const isExperiencesEnabled = Boolean(featureFlags?.['nv1-experiences'])

  return useQuery(
    [GetExperienceQueryKey, restaurantGuid, params.experienceSlug],
    () => getExperience(params.experienceSlug!, restaurantGuid),
    {
      enabled: Boolean(isExperiencesEnabled && params.experienceSlug),
      retry: false
    }
  )
}

export const useGetExperienceByGuid = (params: {
  guid: string | undefined | null
  restaurantGuid: string
}) => {
  const { featureFlags } = useBanquetProps()
  const isExperiencesEnabled = Boolean(featureFlags?.['nv1-experiences'])

  return useQuery({
    ...experiencesQueryOptions(
      params.restaurantGuid,
      DateTime.now().startOf('day').toUTC().toString().replace('Z', '+00:00'),
      Boolean(isExperiencesEnabled && params.guid)
    ),
    // TODO: We should probably move getting this data to its own endpoint, versus getting all the experiences and filtering accordingly
    select(data) {
      return data.find((experience) => experience.guid === params.guid)
    }
  })
}
